//Importación SDK firebase
import firebase from 'firebase/compat/app';
//Importación del servicio de firestore
import 'firebase/compat/firestore';

import {getAuth, signInWithEmailAndPassword  } from 'firebase/auth';

  const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTHDOMAI,
    databaseURL: process.env.REACT_APP_DATABASEURL,
    projectId: process.env.REACT_APP_PROJECTID,
    storageBucket: process.env.REACT_APP_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_APPID,
    measurementId: process.env.REACT_APP_MEASUREMENTID
  };
  
//Inicialización del servicio de firebase
firebase.initializeApp(firebaseConfig);

const auth = getAuth();

signInWithEmailAndPassword(auth, process.env.REACT_APP_FBACCOUNT, process.env.REACT_APP_FBPASS)
  .then((userCredential) => {
    // Signed in
    //const user = userCredential.user;

    //console.log(user)
    // ...
  })
  .catch((error) => {
    //const errorCode = error.code;
    //console.log(errorCode)
    //const errorMessage = error.message;
    //console.log(errorMessage)
  });


//Exportar el espacio de almacenamiento de base de datos firestore
export const pacientesStore = firebase.firestore();
//console.log(pacientesStore)

//Exportar el identificador de la colección de usuarios
export const usersCollection = 'users'

//Exportar el identificador de la colección de unidades hospitalarias
export const uhCollection = 'unidadesservicios'

//Exportar el identificador de la colección de pacientes en quirófano
export const surgeryroomCollection = 'surgeryroom'

//Exportar el identificador de la colección de log de actividades
export const logCollection = 'surgerylog'

//Exportar el identificador de la colección de building (unidades hospitalarias)
export const building = 'building'

//Exportar el identificador de la colección de los resources asignados a un building
export const resources = 'resources'

//export const handleSenMessage = "http://192.168.17.59:3001/HandleSenMessage"
export const handleSenMessage = "https://us-west4-auto-factura-erps.cloudfunctions.net/surgeryroom-notificationsahout"

//Exportar el identificador de la colección de ips
export const ipwhitelist = 'ipwhitelist'